module.exports = "/images/avatar-s-12.jpg?9b7e1e0f0db68323380f3e1acb46e900";